import script from "./MobileInstallationBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileInstallationBanner.vue?vue&type=script&setup=true&lang=ts"

import "./MobileInstallationBanner.vue?vue&type=style&index=0&id=7bd18ff6&lang=scss"

const __exports__ = script;

export default __exports__